import { useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../../../store';
import { useFetchData } from '../../../hooks';
import { BaseModel, PageableResponse } from '../../../types';
import { Resource } from '../../../lib/enums';
import React, { useState } from 'react';
import { Space } from 'antd';
import SelectFilter from '../../../components/ui/filters/SelectFilter';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import { DownloadOutlined } from '@ant-design/icons';

const StockLevelHeaderFilter = ({
  handleExport,
}: {
  handleExport: () => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useAuthStore();
  const { data: defaultLocationData, isLoading: isDefaultLocationLoading } =
    useFetchData<PageableResponse<BaseModel>>('/location/locations', {
      resource: Resource.MIN,
      search: '',
      length: '999999',
    });

  const { data: categoryData, isLoading: isCategoryLoading } = useFetchData<
    PageableResponse<BaseModel>
  >('/product/categories', {
    resource: Resource.MIN,
    search: '',
    length: '999999',
  });
  const [selectedLocationValue, setSelectedLocationValue] = useState<
    string | undefined
  >(searchParams.get('locationId') || user?.defaultLocation?.id);

  const [selectedCategoryValue, setSelectedCategoryValue] = useState<
    string | undefined
  >(searchParams.get('categoryId') || '');

  const handleLocationChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('locationId', value);
      return prev;
    });
    setSelectedLocationValue(value);
  };

  const handleCategoryChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('categoryId', value === undefined ? '' : value);
      return prev;
    });
    setSelectedCategoryValue(value);
  };

  return (
    <>
      <div className={'flex p-4 justify-between'}>
        <Space>
          <label htmlFor="location">Location:</label>
          <SelectFilter
            showSearch={true}
            defaultValue={selectedLocationValue}
            isLoading={isDefaultLocationLoading}
            dataOptions={defaultLocationData?.data.map((item) => ({
              value: item.id,
              label: `${item.code} - ${item.description}`,
            }))}
            handleChange={handleLocationChange}
          />
          <label htmlFor="location">Category:</label>
          <SelectFilter
            allowClear={true}
            showSearch={true}
            defaultValue={selectedCategoryValue}
            isLoading={isCategoryLoading}
            dataOptions={categoryData?.data.map((item) => ({
              value: item.id,
              label: `${item.code} - ${item.description}`,
            }))}
            handleChange={handleCategoryChange}
          />
        </Space>
        <PrimaryButton
          icon={<DownloadOutlined />}
          onClick={handleExport}
          label={'Export'}
        />
      </div>
    </>
  );
};

export default StockLevelHeaderFilter;
